<template>
<div class="SendListContainer">
  <div class="mainContent" :style="styleObject">
    <div class="query">
      <el-input placeholder="请输入规则名称" v-model="queryForm.key"></el-input>
      <!-- <el-input placeholder="角色描述" v-model="queryForm.comment"></el-input>
      <el-select size="small" v-model="queryForm.isSystem" placeholder="是否系统角色" clearable>
        <el-option label="是" value="1" key="1"></el-option>
        <el-option label="否" value="0" key="0"></el-option>
      </el-select>
      <el-select size="small" v-model="queryForm.isEnabled" placeholder="是否启用" clearable>
        <el-option label="启用" value="1" key="1"></el-option>
        <el-option label="禁用" value="0" key="0"></el-option>
      </el-select> -->
      <button class="primaryBtn" @click="search">搜索</button>
      <button class="primaryBtn" @click="handleAddClick('add')">新增</button>
    </div>
    <div class="tableBox contentShowArea">
      <border-table :loading="DatasLoading" :tableData="DataList"  :pageSizes="[10, 20, 50]" :pages="pagination" @currentChange="handleDataCurrentChange" @sizeChange="handleDataSizeChange">
        <el-table-column prop="name" label="规则名称"></el-table-column>
        <el-table-column prop="keyVar" label="规则Key" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="id" label="控制ID" width="160" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="type" label="转发类型">
          <template #default="{row}">
            <span>{{row.type == '1' ? '属性上报' : '事件上报'}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="isDelete" label="状态">
          <template #default="{row}">
            <span
              class="is-delete"
              :style="{ color: row.isDelete ? '#13CE66' : '#FF4949'}">
              {{row.isDelete ? '启用' : '禁用'}}
            </span>
            <el-switch
              v-model="row.isDelete"
              @change="handleSwithChange($event, row.id)"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" sortable="custom"></el-table-column>
        <el-table-column prop="url" label="转发路径" width="180" show-overflow-tooltip></el-table-column>
        
        <el-table-column fixed="right" label="操作" width="170">
          <template #default="{row}">
            <el-button class="editBtn" type="text" @click="handleAddClick('view', row)" >查看</el-button> 
            <el-button :style="{color:row.isDelete ? '#ccc':'#28C6A2'}" class="editBtn" type="text" icon="el-icon-edit-outline" @click="handleAddClick('edit', row)" :disabled="row.isDelete">编辑</el-button> 
            <el-button :style="{color:row.isDelete ? '#ccc':'#DD3071'}" class="delBtn" type="text" icon="el-icon-delete" :disabled="row.isDelete" @click="handleDeleteClick(row.id)" :loading="isDeleting">删除</el-button>
          </template>
        </el-table-column>
      </border-table>
    </div>
  </div>

  <el-drawer :title="dataDrawer.title" size="800px" :modal="false" :visible.sync="dataDrawer.show" @close="handleDrawerClose" :wrapperClosable="false" direction="rtl" ref="drawer">
    <div class="drawerWrap">
      <div class="drawerBody">
        <el-form class="formBox" ref="dataDrawerForm" :model="dataDrawer.form" :rules="dataDrawer.formRules" label-position="right" label-width="120px">
          <el-form-item label="规则名称" prop="name">
            <el-input v-model.trim="dataDrawer.form.name" type="text" :maxlength="30" placeholder="请输入规则名称" :disabled="!isShow"></el-input>
          </el-form-item>
          <el-form-item label="规则Key" prop="urlKey">
            <el-select v-model="dataDrawer.form.urlKey" placeholder="请选择" :disabled="!isShow">
              <el-option
                v-for="item in urlKeyOptions"
                :key="item.urlKey"
                :label="item.keyVar"
                :value="item.urlKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规则备注" prop="commtie">
            <el-input v-model.trim="dataDrawer.form.commtie" type="textarea" :maxlength="50" :rows="3" placeholder="请输入规则备注" :disabled="!isShow"></el-input>
          </el-form-item>
          <el-form-item label="数据类型" prop="type">
            <el-select v-model="dataDrawer.form.type" placeholder="请选择" :disabled="!isShow" @change="handleChangeType">
              <el-option label="标签上报" value="1"></el-option>
              <el-option label="类型上报" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据来源" prop="deviceUrl">
            <el-select v-model="dataDrawer.form.deviceUrl" placeholder="请选择" :disabled="!isShow">
              <el-option
                v-for="(item, index) in OriginOptions"
                :key="index"
                :label="item.value"
                :value="item.key">
              </el-option>
            </el-select>
            <!-- <el-select v-model="dataDrawer.form.deviceUrl" placeholder="请选择" :disabled="!isShow">
              <el-option label="所有设备" value="0"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="路径类型" prop="urltype">
            <el-select v-model="dataDrawer.form.urltype" placeholder="请选择" :disabled="!isShow">
              <el-option label="HTTP" value="1"></el-option>
            </el-select>
            <p style="line-height: 10px;color:#ccc;font-size: 12px;">为安全起见，HTTP路径类型的传送方法默认为POST</p>
          </el-form-item>
          <el-form-item label="转发路径" prop="url">
            <el-input v-model.trim="dataDrawer.form.url" type="text" placeholder="请输入转发路径" :disabled="!isShow"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawerFoot" v-if="isShow">
        <el-button type="primary" @click="handleAddSave" :loading="dataDrawer.saving">{{ dataDrawer.saving ? '提交中' : '提交' }}</el-button>
        <el-button @click="dataDrawer.show = false">取 消</el-button>
      </div>
    </div>
  </el-drawer>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable.vue";
import OneGroupCheckboxs from "@/components/common/OneGroupCheckboxs";
import {
  log
} from 'util';
export default {
  components: {
    BorderTable,
    OneGroupCheckboxs
  },
  data() {
    return {
      styleObject: {
        height: ""
      },
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      tableHeight: null,
      DatasLoading: false,
      isDeleting: false,
      DataList: [],
      dataDrawer: {
        show: false,
        title: "新增推送",
        checkAll: {
          value: false
        },
        form: {
          name: '',
          urlKey: '',
          commtie: '',
          type: '1',
          deviceUrl: '',
          urltype: '1',
          url: '',
        },
        formRules: {
          name: [{
            required: true,
            message: "规则名称不能为空",
            trigger: "blur"
          }],
          urlKey: [{
            required: true,
            message: "规则Key不能为空",
            trigger: "blur"
          }],
          type: [{
            required: true,
            message: "数据类型不能为空",
            trigger: "blur"
          }],
          deviceUrl: [{
            required: true,
            message: "数据来源不能为空",
            trigger: "blur"
          }],
          urltype: [{
            required: true,
            message: "转发类型不能为空",
            trigger: "blur"
          }],
          url: [{
            required: true,
            message: "转发路径不能为空",
            trigger: "blur"
          }]
        },
        saving: false,
        privileges: []
      },
      selfDataMapper: {},
      queryForm: {
        orgId: -1,
        key: ''
      },
      urlKeyOptions: [],
      isShow: true,
      OriginOptions: []
    };
  },
  computed: {
    currentTreeId() {
      return this.$store.state.currentTreeId;
    },
    screenData() {
      return this.$store.state.screen;
    }
  },
  watch: {
    screenData() {
      this.tableHeight = document.body.clientHeight - 350 + "px";
    }
  },
  created() {
    this.isGoNextPage();
    this.makeheight();
    this.getUrlKeyData()
    // this.tableHeightInit();
  },
  mounted() {
    this.getDataOrgin(1);
    this.queryDataList();
  },
  methods: {
    // 判断该用户是否有权限访问该页面
    isGoNextPage () {
      this.request.get('/front/system/urltag/findtenant').then(res => {
        if (res.code == 200) {
          if (res.msg != 200) {
            this.$router.replace({ name: 'noView' })
          }
        } else {
          this.$router.replace({ name: 'noView' })
        }
      })
    },
    handleChangeType (e) {
      this.getDataOrgin(e)
      this.dataDrawer.form.deviceUrl = ''
    },
    getDataOrgin (type) {
      this.request.get('/front/system/urltag/typelist', { type }).then(res => {
        console.log(res)
        if (res.code == 200) {
          this.OriginOptions = res.data
        }
      })
    },
    search() {
      this.pagination.currentPage = 1;
      this.queryDataList();
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      _this.tableHeight = window.innerHeight - 340;
      console.log(_this.tableHeight);
      window.onresize = () => {
        return (() => {
          _this.tableHeight = window.innerHeight - 340;
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    tableHeightInit() {
      this.tableHeight = document.body.clientHeight - 350 + "px";
    },
    /**
     * @Description 请求数据列表
     * @Author      YOYO     -             2022-07-05
     */
    queryDataList() {
      let { currentPage, pageSize } = this.pagination
      this.DatasLoading = true;
      let defaults = {
        page: currentPage,
        pageSize,
        sort: 'createTime',
        order: 'desc'
      }
      let params = Object.assign(defaults, this.queryForm)
      this.request.get("/front/system/config/urlquery", params)
        .then(rs => {
          if (rs.code == 200) {
            console.log(rs.data.data)
            this.DataList = rs.data.data || []
            this.pagination.total = rs.data.totalCount
          } else {}
          this.DatasLoading = false;
        })
        .catch(error => {
          console.error(error);
          this.DatasLoading = false;
        });
    },
    /**
     * @Description 新增数据
     * @Author      YOYO     -             2022-07-05
     */    
    handleAddClick(type, data) {
      this.isShow = type == 'view' ? false : true
      this.dataDrawer.show = true;
      this.dataDrawer.title = '新增推送';

      let form = {
        name: '',
        urlKey: '',
        commtie: '',
        type: '1',
        deviceUrl: '',
        urltype: '1',
        url: ''
      }
      if (type == 'edit' || type == 'view') {
        this.getDataOrgin(data.type);
        this.dataDrawer.title = type == 'edit' ? '编辑推送' : '查看推送'
        form = data
      }
      this.dataDrawer.form = form
    },
    /**
     * @Description 规则key下拉列表
     * @Author      YOYO     -             2022-07-05
     */
    getUrlKeyData () {
      this.request.get("/front/system/config/findurl").then(res => {
        if (res.code === 200) {
          this.urlKeyOptions = res.data || []
          if (res.data && res.data[0]) {
            this.dataDrawer.form.urlKey = res.data[0].urlKey
          }
        }
      })
    },
    /**
     * @Description 切换列表页数
     * @Author      YOYO     -             2022-07-05
     */
    handleDataCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage;
      this.queryDataList();
    },
    /**
     * @Description 切换列表分页大小
     * @Author      YOYO     -             2022-07-05
     */
    handleDataSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.currentPage = 1;
      this.queryDataList();
    },
    handleDrawerClose () {
      this.dataDrawer.show = false
    },
    handleAddSave () {
      this.$refs['dataDrawerForm'].validate((valid) => {
        if (valid) {
          let params = this.dataDrawer.form
          this.dataDrawer.saving = true
          this.request.get('/front/system/config/urladdoredit', params).then(res => {
            this.dataDrawer.saving = false
            this.dataDrawer.show = false
            let msgText = params.id ? '编辑' : '提交'
            if (res.code === 200) {
              this.$message({ type: 'success', message: `${msgText}成功！`})
              this.pagination.currentPage = 1
              this.queryDataList()
            } else {
              this.$message({ type: 'error', message: `${msgText}失败！请重新提交`})
            }
          })
        } else {
          this.$message({ type: 'warning', message: '请按照要求填写正确信息！'})
          return false;
        }
      })
    },
    // 删除列表
    handleDeleteClick (id) {
      this.$confirm('此操作将永久删除该条信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDeleting = true
          this.request.get('/front/system/config/deleteurl', { id }).then(res => {
            this.isDeleting = false
            if (res.code === 200) {
              this.$message({ type: 'success', message: '删除成功！'})
              this.pagination.currentPage = 1
              this.queryDataList()
            } else {
              this.$message({ type: 'error', message: '删除失败！请重重试'})
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })         
        })
    },
    // 是否启用
    handleSwithChange (e, id) {
      this.request.get('/front/system/config/urlup', { id, isDelete: e}).then(res => {
        if (res.code == 200) {
          this.$message({ type: 'success',  message: '操作成功！'})
        } else {
          this.$message({ type: 'error',  message: '操作失败！'})
        }
        this.queryDataList();
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.SendListContainer {
  .mainContent {
    margin: 12px;
    padding: 15px 0;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .query {
      padding: 0 20px 20px;
    }

    .tableBox {
      padding: 0 20px;
    }

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }

    .detail {
      background: #32AC63;
      color: #fff;
    }
  }
}
</style>
<style lang="scss">
.SendListContainer {
  .drawerWrap .el-form .el-form-item__content .el-textarea{
    width: 600px;
  }
  .drawerWrap .el-form .el-form-item__content .el-input{
    width: 600px;
  }
  .mainContent {
    .query {
      .el-input {
        width: 200px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }

      .el-select {
        width: 170px;
        margin-right: 10px;

        .el-input {
          width: 170px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 36px;
            height: 36px;
          }
        }
      }

      .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
        border-color: #42bced;
        background: #42bced;
      }

      .el-radio.is-checked .el-radio__label {
        color: #147dd9 !important;
      }
    }

  }

  .formBox {
    .el-form-item {
      .content-panel {
        line-height: 40px;

        &>.el-checkbox {
          line-height: 50px;
        }
      }

      .privilege-form-item {
        padding: 0 10px;
      }
    }

  }

  .contentShowArea {

    .el-table__fixed-right {
      &::before {
        display: none;
      }

      .el-table__fixed-body-wrapper {
        tbody {
          tr {
            td {
              // border: none;
              // padding: 9px 0;

              .cell {
                text-align: center;

                .editBtn {
                  color: #28c6a2;
                }

                .delBtn {
                  color: #dd3071;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
